export const SUPPLIER_ADD = 1
export const SUPPLIER_VIEW = 2
export const SUPPLIER_EDIT = 3
export const SUPPLIER_DELETE = 4
export const SUPPLIER_IMPORT = 38
export const DASHBOARD_VIEW = 5
export const CLIENT_ADD = 6
export const CLIENT_VIEW = 7
export const CLIENT_EDIT = 8
export const CLIENT_DELETE = 9
export const CLIENT_IMPORT = 36
export const USER_ADD = 10
export const USER_VIEW = 11
export const USER_EDIT = 12
export const USER_DELETE = 13
export const ROLE_ADD = 14
export const ROLE_VIEW = 15
export const ROLE_EDIT = 16
export const ROLE_DELETE = 17
export const PATIENT_ADD = 18
export const PATIENT_VIEW = 19
export const PATIENT_EDIT = 20
export const PATIENT_DELETE = 21
export const PATIENT_IMPORT = 35
export const TRANSPORTER_ADD = 22
export const TRANSPORTER_VIEW = 23
export const TRANSPORTER_EDIT = 24
export const TRANSPORTER_DELETE = 25
export const TRANSPORTER_IMPORT = 34
export const EXPENSE_CATEGORY_ADD = 26
export const EXPENSE_CATEGORY_VIEW = 27
export const EXPENSE_CATEGORY_EDIT = 28
export const EXPENSE_CATEGORY_DELETE = 29
export const EXPENSE_ADD = 30
export const EXPENSE_VIEW = 31
export const EXPENSE_EDIT = 32
export const EXPENSE_DELETE = 33
export const BATCH_ADD = 39
export const BATCH_VIEW = 40
export const BATCH_EDIT = 41
export const BATCH_DELETE = 42
export const BATCH_VIEW_DETAIL = 43
export const BATCH_PLANT_ADD = 44
export const BATCH_PLANT_VIEW = 45
export const BATCH_PLANT_EDIT = 46
export const BATCH_PLANT_DELETE = 47
export const PLANT_VIEW = 48
export const INVENTORY_ADD = 49
export const INVENTORY_VIEW = 50
export const INVENTORY_EDIT = 51
export const INVENTORY_DELETE = 52
export const PRODUCT_CATEGORY_ADD = 53
export const PRODUCT_CATEGORY_VIEW = 54
export const PRODUCT_CATEGORY_EDIT = 55
export const PRODUCT_CATEGORY_DELETE = 56
export const PRODUCT_ADD = 57
export const PRODUCT_VIEW = 58
export const PRODUCT_EDIT = 59
export const PRODUCT_DELETE = 60
export const PRODUCT_PRINT_LABEL = 61
export const PRODUCT_IMPORT = 96
export const TAX_VIEW = 62
export const TAX_EDIT = 63
export const SALE_ADD = 64
export const SALE_VIEW = 65
export const SALE_EDIT = 66
export const SALE_DELETE = 67
export const SALE_PALYMENT_ADD = 68
export const SALE_PALYMENT_VIEW = 69
export const SALE_PALYMENT_DELETE = 70
export const SALE_RETURN_ADD = 71
export const SALE_RETURN_VIEW = 72
export const SALE_RETURN_EDIT = 73
export const SALE_RETURN_DELETE = 74
export const MARKET_PLACE_VIEW = 75
export const MARKET_PLACE_ADD = 76
export const LAB_ADMIN_ADD = 77
export const LAB_ADMIN_VIEW = 78
export const LAB_ADMIN_EDIT = 79
export const LAB_ADMIN_DELETE = 80
export const LAB_TESTING_ADD = 81
export const LAB_TESTING_VIEW = 82
export const LAB_TESTING_EDIT = 83
export const LAB_TESTING_DELETE = 84
export const SALES_RETURN_REPORT = 85
export const EXPENSE_REPORT = 86
export const TAX_REPORT = 87
export const STOCK_REPORT = 88
export const ITEM_SALES_REPORT = 89
export const SALES_PAYMENT_REPORT = 90
export const SALES_REPORT = 91
export const PROFIT_AND_LOSS_REPORT = 92
export const PROCESSOR_REPORT = 93
export const DISPENSARY_REPORT = 94
export const CULTIVATOR_REPORT = 95
export const STRAIN_ADD = 97
export const STRAIN_VIEW = 98
export const STRAIN_EDIT = 99
export const STRAIN_DELETE = 100
export const DISCOUNT_SETUP_ADD = 101
export const DISCOUNT_SETUP_VIEW = 102
export const DISCOUNT_SETUP_EDIT = 103
export const DISCOUNT_SETUP_DELETE = 104
export const LOCATION_ADD = 105
export const LOCATION_VIEW = 106
export const LOCATION_EDIT = 107
export const LOCATION_DELETE = 108
export const REGISTER_ADD = 109
export const REGISTER_VIEW = 110
export const REGISTER_EDIT = 111
export const REGISTER_DELETE = 112
export const CASH_DROP_ADD = 113
export const CASH_DROP_VIEW = 114
export const CASH_DROP_EDIT = 115
export const CASH_DROP_DELETE = 116
export const CASH_FLOAT_ADD = 117
export const CASH_FLOAT_VIEW = 118
export const CASH_FLOAT_EDIT = 119
export const CASH_FLOAT_DELETE = 120
export const CASH_DROP_REPORT = 121
export const CASH_FLOAT_REPORT = 122
export const PUNCH_CLOCK_ADD = 123
export const PUNCH_CLOCK_VIEW = 124
export const PUNCH_CLOCK_EDIT = 125
export const PUNCH_CLOCK_DELETE = 126
export const PROMO_DISCOUNT_ADD = 127
export const PROMO_DISCOUNT_VIEW = 128
export const PROMO_DISCOUNT_EDIT = 129
export const PROMO_DISCOUNT_DELETE = 130
export const REWARDS_DISCOUNT = 131
export const TIRED_PRICING = 132
export const TRANSFER_ADD = 133
export const TRANSFER_VIEW = 134
export const TRANSFER_EDIT = 135
export const TRANSFER_DELETE = 136
export const PRODUCT_HISTORICAL_REPORT = 137
